// preSubscribeAgoraClient.js
'use strict';
import { AGORA_RTC_APP_ID } from '../RemoteConfigKeys.js';
import getLiveStreamData from '../selector/getLiveStreamData.js';
import getRemoteConfigData from '../selector/getRemoteConfigData.js';
import getMeData from '../selector/getMeData.js';
import { joinChannelWithSubscribing } from '../resource/agora.js';

/** @kind action Pre-subscribe a prejoined Agora channel's tracks during swipe. */
const preSubscribeAgoraClient =
  ({ streamId }) =>
  async (dispatch, getState) => {
    if (!streamId) return dispatch({ type: '' });
    const state = getState();
    const sessionId = getLiveStreamData(state, [streamId], 'sessionId');
    if (!sessionId) return dispatch({ type: '' });
    const appId = getRemoteConfigData(state, AGORA_RTC_APP_ID);
    const token = getLiveStreamData(
      state,
      [streamId, 'providerInfo', 'agora'],
      'agoraToken'
    );
    const meSessionId = getMeData(state, 'sessionId');
    if (!appId || !token || !meSessionId) return dispatch({ type: '' });
    return joinChannelWithSubscribing({
      appId,
      channelId: sessionId,
      token,
      sessionId: meSessionId,
      isActive: false,
    });
  };

export default preSubscribeAgoraClient;
